"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeStorage = exports.readStorage = void 0;
/**
 * localStorage 접근을 예외로부터 보호한다. 저장소를 막은 브라우저와 일부 웹뷰에서는 접근만 해도 예외가 나므로,
 * 읽기는 값이 없는 것으로, 쓰기는 이번 방문에서만 적용하는 것으로 처리해 저장이 안 되는 환경에서도 화면이 동작하게 한다.
 */
function readStorage(key) {
    try {
        return localStorage.getItem(key);
    }
    catch {
        return null;
    }
}
exports.readStorage = readStorage;
function writeStorage(key, value) {
    try {
        localStorage.setItem(key, value);
    }
    catch {
        // 저장할 수 없는 환경에서는 저장 없이 넘어간다.
    }
}
exports.writeStorage = writeStorage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInN0b3JhZ2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUE7OztHQUdHO0FBQ0gsU0FBZ0IsV0FBVyxDQUFDLEdBQVc7SUFDckMsSUFBSTtRQUNGLE9BQU8sWUFBWSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQTtLQUNqQztJQUFDLE1BQU07UUFDTixPQUFPLElBQUksQ0FBQTtLQUNaO0FBQ0gsQ0FBQztBQU5ELGtDQU1DO0FBRUQsU0FBZ0IsWUFBWSxDQUFDLEdBQVcsRUFBRSxLQUFhO0lBQ3JELElBQUk7UUFDRixZQUFZLENBQUMsT0FBTyxDQUFDLEdBQUcsRUFBRSxLQUFLLENBQUMsQ0FBQTtLQUNqQztJQUFDLE1BQU07UUFDTiw2QkFBNkI7S0FDOUI7QUFDSCxDQUFDO0FBTkQsb0NBTUMifQ==